// 统计与日志
export default [
  {
    path: '/statistics',
    redirect: '/statistics/account',
  },
  {
    path: '/statistics/account',
    name: 'statistics-account',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/statistics/account/Index.vue'),
    meta: { title: '账号统计' },
  },
  {
    path: '/statistics/crash',
    name: 'system-crash',
    component: () => import(/* webpackChunkName: "statistics" */ '@/views/system/crash/Index.vue'),
    meta: { title: '崩溃日志' },
  },
];
